import { createIpaPlatform, createSandboxRosTemplate, guestLogin } from '@services/youtube-platform.service';
import { useContext, useEffect, useState } from 'react';
import { getAuth } from '@services/identity.service';
import { TeamsDataContext } from '@components/context/TeamsContext';
import { getRosPreviewSession, setRosPreviewSession } from '@services/ros-preview.service';
import SandboxWebsitePreview from '@components/Sandbox/website-preview';

export default function WebsiteSandboxPreviewPage({
  platform,
  oTemplateId
}: any) {
  const [platformId, setPlatformId] = useState(null);
  const [templateId, setTemplateId] = useState(null);

  const { teamContext } = useContext(TeamsDataContext);

  const findOrCreateSandboxPlatform = async () => {
    const res = await createIpaPlatform({ userId: teamContext?.oid });
    setPlatformId(res.entity[0].platform_id);
  };

  const findOrFetchTemplate = async () => {
    const rosPreviewSession = getRosPreviewSession();

    if (!rosPreviewSession) return;

    const template = await createSandboxRosTemplate(rosPreviewSession);
    setTemplateId(template.entity.id);
  };

  useEffect(() => {
    if (teamContext?.oid) {
      findOrCreateSandboxPlatform();
    }
  }, [teamContext]);

  useEffect(() => {
    if (oTemplateId) {
      const auth = getAuth();
      setRosPreviewSession(`${auth.id}:${oTemplateId}`);
    }
    findOrFetchTemplate();
  }, []);

  if (!platformId || !templateId) return null;

  return <SandboxWebsitePreview
    is_ros_preview={false}
    templateId={templateId}
    platform={platform}
    platformId={platformId}
  />;
}

export const getServerSideProps = async ({ query }: any) => {
  const {
    platform = 'zoom',
    oTemplateId = ''
  } = query;

  const props: any = { platform };
  if (oTemplateId) {
    props.oTemplateId = oTemplateId;
  }
  return { props };
};
